<template>
    <div :class="[$route.name === 'Step1' || $route.name === 'Step_1' || $route.name === 'Step1Portal' || $route.name === 'Step2' ? 'full-wrapper  bg-mountains': 'posl']">
        <div class="bt-container">
            <page-header ref="PageHeader"></page-header>

            <!-- Step1 -->
            <div class="bt-content" :class="[$route.name === 'Step1' || $route.name === 'Step_1' || $route.name === 'Step1Portal' || $route.name === 'Step2' ? 'm-t-100': '']">
                <router-view :key="$route.fullPath" v-if="storage_loaded"></router-view>
                <div class="overlay-loader" v-if="isLoading">
                    <i class="overlay-img-load"></i>
                </div>
                <!-- step2 -->

            </div>


        </div>
        <!-- bt-container -->
        <div class=" footer_container" v-if="$route.name !== 'Step1Portal'">
            <div class="footer">
                <p>&copy; {{ app_name }} | Privacy & Security</p>
            </div>
        </div>
    </div>

</template>


<script>

import {mapState, mapActions} from "vuex";
import PageHeader from "../layouts/Header";
import helpers from "../../resources/assets/js/helpers";

export default {
    name: 'FrontApp',
    components: {PageHeader},
    computed: {
        ...mapState(['isLoading', 'app_name', 'form', 'auth_user', 'storage_loaded']),
    },
    created() {
        this.$store.dispatch('setDataFromStorage');
        this.$store.dispatch('fetchAllResorts');
    },
    mounted() {
        if (this.auth_user) {
            //if logged out from simple web page need to logged out from vue too.
            this.checkLoggedInOrNot();
        }
    },

    methods: {
        checkLoggedInOrNot() {
            let _this = this;
            this.$store.dispatch('setLoading', {'loading': true});

            axios.post('/front_api/auth/check')
                .then(res => {
                    this.$store.dispatch('setLoading', {'loading': false});
                    if (res.data.data.is_logged_in === 'yes') {
                        let user = res.data.data.user;
                        _this.setUser(user);
                        if(user){
                            _this.form.first_name = user.first_name;
                            _this.form.lang = user.lang;
                            _this.form.last_name = user.last_name;
                            _this.form.email = user.email;
                            _this.form.phone = user.phone;
                            _this.form.dial_code =  user.dial_code;
                        }
                        _this.setAuthUser();
                    }else{
                        console.log('logout');
                        localStorage.removeItem('getUser');
                        localStorage.removeItem('getToken');
                        _this.$store.dispatch('resetStorageAndStore');
                        _this.$store.state.auth_user = helpers.getUser();
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.$store.dispatch('setLoading', {'loading': false});
                    localStorage.removeItem('getUser');
                    localStorage.removeItem('getToken');
                    this.$store.dispatch('resetStorageAndStore');
                    this.$store.state.auth_user = helpers.getUser();
                });


        },
        ...mapActions(['setAuthUser'])
    }
}
</script>
